import React from "react";
import { useStoreWorkspaces } from "../stores/useStoreWorkspaces";
import Image from "./Tags/Image";
import Text from "./Tags/Text";
import { Button } from "./ui/button";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { acceptInvite, declineInvite } from "../apis/workspace/members";
import { NavLink } from "react-router-dom";
import TooltipWrapper from "./TooltipWrapper";

export default function InvitationsCard() {
  const queryClient = useQueryClient();

  const { pendingInvitations } = useStoreWorkspaces();
  console.log("pendingInvitations", pendingInvitations);
  const acceptInviteFn = useMutation("accept_invite", acceptInvite, {
    onSuccess(data, variables, context) {
      toast.success(data?.message);
      queryClient.invalidateQueries("get_workspaces");
    },
    onError(error) {
      console.log(error);
    },
  });
  const handleAcceptInvite = (payload) => {
    if (acceptInviteFn.isLoading) {
      return;
    }
    acceptInviteFn.mutate({ ...payload });
  };

  // handle decline invite
  const declineInviteFn = useMutation("decline_invite", declineInvite, {
    onSuccess(data, variables, context) {
      toast.success(data?.message);
      queryClient.invalidateQueries("get_workspaces");
    },
    onError(error) {
      console.log(error);
    },
  });
  const handleDeclineInvite = (payload) => {
    if (declineInviteFn.isLoading) {
      return;
    }
    declineInviteFn.mutate({ ...payload });
  };

  const renderWorkspaceIcon = (icon) => {
    return (
      <>
        {icon ? (
          <Image
            src={icon}
            className="w-[24px] h-[24px] rounded-full no-invert"
            width={24}
            height={24}
            nobaseurl
          />
        ) : (
          <Image src={`/images/icons/untitledui/org.svg`} className="no-invert" width={24} height={24} />
        )}
      </>
    );
  };

  return (
    <div>
      {pendingInvitations && pendingInvitations.length > 0 && (
        <>
          {pendingInvitations.length > 1 ? (
            <div className="border border-brand-200 rounded-lg bg-brand-50 p-4">
              <div className="flex">
                {pendingInvitations.map((item, index) => (
                  <TooltipWrapper content={item?.workspace?.name} className="inline-block">
                    <div
                      key={index}
                      className={`${index !== 0 ? "-ml-5" : ""} bg-white p-1 rounded-md shadow`}
                    >
                      {renderWorkspaceIcon(item?.workspace?.icon)}
                    </div>
                  </TooltipWrapper>
                ))}
              </div>

              <Text size="sm" className="mt-2.5 mb-2">
                You have {pendingInvitations.length} pending invitations
              </Text>
              <Text size="p" className="mb-3">
                Accept workspace invitations to join your team
              </Text>
              <Button asChild>
                <NavLink to={`/workspaces`}>See all invites</NavLink>
              </Button>
            </div>
          ) : (
            <div className="border border-brand-200 rounded-lg bg-brand-50 p-4">
              <NavLink to={`/workspaces`}>
                {pendingInvitations[0]?.workspace?.icon ? (
                  <Image
                    src={pendingInvitations[0]?.workspace?.icon}
                    className="mr-2 w-[24px] h-[24px] rounded-full no-invert"
                    width={24}
                    height={24}
                    nobaseurl
                  />
                ) : (
                  <Image src={`/images/icons/untitledui/org.svg`} className="mr-2" width={24} height={24} />
                )}
                <Text size="sm" className="mt-2.5 mb-2">
                  {pendingInvitations[0]?.sent_by?.name} sent an invite!
                </Text>
                <Text size="p" className="mb-3">
                  You have been invited to join <b>{pendingInvitations[0]?.workspace?.name}</b> workspace.
                </Text>
                <div className="flex space-x-2">
                  <Button
                    className="w-full"
                    disabled={acceptInviteFn.isLoading || declineInviteFn.isLoading}
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      handleAcceptInvite({
                        invitation_id: pendingInvitations[0]?.id,
                        token: pendingInvitations[0]?.token,
                      });
                    }}
                  >
                    Accept Invite
                    {acceptInviteFn.isLoading && <div className="loader_circle ml-2"></div>}
                  </Button>
                  {/* <Button
                  className="w-full"
                  variant="danger-outline"
                  disabled={acceptInviteFn.isLoading || declineInviteFn.isLoading}
                  onClick={() => {
                    handleDeclineInvite({
                      invitation_id: pendingInvitations[0]?.id,
                      token: pendingInvitations[0]?.token,
                    });
                  }}
                >
                  Decline
                  {declineInviteFn.isLoading && <div className="loader_circle ml-2"></div>}
                </Button> */}
                </div>
              </NavLink>
            </div>
          )}
        </>
      )}
    </div>
  );
}
